import { render, staticRenderFns } from "./KycTable.vue?vue&type=template&id=6e851c4c&scoped=true&"
import script from "./KycTable.vue?vue&type=script&lang=js&"
export * from "./KycTable.vue?vue&type=script&lang=js&"
import style0 from "./KycTable.vue?vue&type=style&index=0&id=6e851c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e851c4c",
  null
  
)

export default component.exports